import Vue from 'vue'
import App from './App'
import VueResource from 'vue-resource'
import './assets/font/font.css'
import { sysDialog, sysLoading, sysSwiper } from "./components/common"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.use(VueResource)
Vue.use(sysDialog)
Vue.use(sysLoading)
Vue.use(sysSwiper)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js